// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2720%27 height=%2720%27 viewBox=%270 0 20 20%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.05%27%3E%3Ccircle cx=%273%27 cy=%273%27 r=%271%27/%3E%3Ccircle cx=%2713%27 cy=%2713%27 r=%271%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chatbot Component Styles - Forward Sumner Brand Compliant */

/* CSS Custom Properties for easy theming */
:root {
  --chatbot-shadow-light: 0 4px 12px rgba(27, 44, 90, 0.15);
  --chatbot-shadow-medium: 0 6px 20px rgba(27, 44, 90, 0.25);
  --chatbot-shadow-heavy: 0 20px 40px rgba(27, 44, 90, 0.25);
  --chatbot-transition-fast: 0.2s ease;
  --chatbot-transition-medium: 0.3s ease;
  --chatbot-transition-slow: 0.5s ease;
  --chatbot-border-radius: 1rem;
  --chatbot-border-radius-small: 0.75rem;
  --chatbot-border-radius-large: 1.5rem;
}

/* Dynamic z-index for tooltip compatibility */
.chatbot-container.chatbot-low-zindex {
  z-index: 10; /* Lower than tooltips when they're open */
}

/* Main Container */
.chatbot-container {
  position: fixed;
  bottom: 6rem; /* Moved up further to avoid overlap with Job Postings bar */
  right: 1rem;
  z-index: 9999; /* Highest z-index to ensure chatbot appears on top of all pages */
  font-family: var(--font-body);
  /* Ensure it's above other elements */
  isolation: isolate;
  /* CRITICAL: Ensure entire container stays within ALL viewport boundaries */
  max-width: calc(100vw - 2rem);
  max-height: calc(100vh - 7rem);
  /* Prevent overflow on all sides */
  top: auto;
  left: auto;
  /* Ensure minimum spacing from edges */
}

/* Chat Toggle Button */
.chatbot-toggle-button {
  background: var(--primary-blue);
  color: var(--primary-white);
  border: none;
  border-radius: 50%;
  padding: 1rem;
  cursor: pointer;
  box-shadow: var(--chatbot-shadow-light);
  transition: all var(--chatbot-transition-medium);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Improved hover effects */
  position: relative;
  overflow: hidden;
  /* CRITICAL: Ensure button doesn't overflow viewport */
  width: 3.75rem;
  height: 3.75rem;
  max-width: 3.75rem;
  max-height: 3.75rem;
  /* Prevent any size changes that could cause overflow */
  flex-shrink: 0;
  box-sizing: border-box;
}

.chatbot-toggle-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left var(--chatbot-transition-slow);
}

.chatbot-toggle-button:hover::before {
  left: 100%;
}

.chatbot-toggle-button:hover {
  background: var(--primary-gold);
  transform: scale(1.1) rotate(5deg);
  box-shadow: var(--chatbot-shadow-medium);
}

.chatbot-toggle-button:active {
  transform: scale(0.95);
  transition: transform var(--chatbot-transition-fast);
}

.chatbot-toggle-button.chatbot-minimized {
  padding: 0.75rem;
  animation: chatbot-pulse 2s infinite;
}

@keyframes chatbot-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.chatbot-icon {
  width: 1.75rem;
  height: 1.75rem;
  transition: transform var(--chatbot-transition-medium);
}

.chatbot-toggle-button:hover .chatbot-icon {
  transform: scale(1.1);
}

/* Chat Window */
.chatbot-window {
  background: var(--primary-white);
  border-radius: var(--chatbot-border-radius);
  box-shadow: var(--chatbot-shadow-heavy);
  border: 1px solid var(--secondary-light-gray);
  width: 32rem;
  height: 45rem;
  /* CRITICAL: Never exceed viewport boundaries on ANY side */
  max-width: calc(100vw - 2rem);
  max-height: calc(100vh - 7rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Smooth entrance animation */
  animation: chatbot-slide-up 0.3s ease-out;
  /* Glass morphism effect */
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
  /* Ensure it stays within viewport */
  position: relative;
  /* Prevent all overflow */
  box-sizing: border-box;
  margin-left: auto;
  margin-right: 0;
  /* Additional safety: prevent bottom overflow */
  margin-bottom: 0;
}

@keyframes chatbot-slide-up {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Header */
.chatbot-header {
  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);
  color: var(--primary-white);
  padding: 1rem;
  border-radius: var(--chatbot-border-radius) var(--chatbot-border-radius) 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Enhanced header with subtle pattern */
  position: relative;
  overflow: hidden;
}

.chatbot-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

.chatbot-header-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  position: relative;
  z-index: 1;
}

.chatbot-avatar {
  width: 2.5rem;
  height: 2.5rem;
  background: var(--primary-white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Enhanced avatar with shadow */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all var(--chatbot-transition-medium);
}

.chatbot-avatar:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.chatbot-avatar-text {
  color: var(--primary-blue);
  font-weight: bold;
  font-size: 1rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.chatbot-header-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.chatbot-title {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 1rem;
  margin: 0;
  line-height: 1.2;
  color: var(--primary-white);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.chatbot-subtitle {
  font-size: 0.8rem;
  margin: 0;
  opacity: 0.9;
  line-height: 1.2;
  font-weight: 300;
}

.chatbot-header-actions {
  display: flex;
  gap: 0.5rem;
  position: relative;
  z-index: 1;
}

.chatbot-header-button {
  background: none;
  border: none;
  color: var(--primary-white);
  padding: 0.5rem;
  border-radius: var(--chatbot-border-radius-small);
  cursor: pointer;
  transition: all var(--chatbot-transition-fast);
  opacity: 0.8;
  /* Enhanced button styling */
  position: relative;
  overflow: hidden;
}

.chatbot-header-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transition: all var(--chatbot-transition-fast);
  transform: translate(-50%, -50%);
}

.chatbot-header-button:hover::before {
  width: 100%;
  height: 100%;
}

.chatbot-header-button:hover {
  opacity: 1;
  transform: scale(1.1);
}

.chatbot-header-icon {
  width: 1.1rem;
  height: 1.1rem;
  transition: transform var(--chatbot-transition-fast);
}

.chatbot-header-button:hover .chatbot-header-icon {
  transform: scale(1.2);
}

/* Messages */
.chatbot-messages {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
  background: linear-gradient(135deg, var(--secondary-light-gray), #f8f9fa);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* Enhanced scrollbar */
  scrollbar-width: thin;
  scrollbar-color: var(--secondary-dark-gray) transparent;
  /* Ensure content doesn't overflow horizontally */
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.chatbot-message {
  display: flex;
  animation: chatbot-message-fade-in 0.3s ease-out;
}

@keyframes chatbot-message-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chatbot-message-user {
  justify-content: flex-end;
}

.chatbot-message-ai {
  justify-content: flex-start;
}

.chatbot-message-bubble {
  max-width: 18rem;
  padding: 0.75rem 1rem;
  border-radius: var(--chatbot-border-radius-large);
  position: relative;
  /* Enhanced bubble styling */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all var(--chatbot-transition-fast);
  /* Ensure content doesn't overflow */
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
}

/* Wider bubble for AI responses with tables */
.chatbot-message-bubble-ai:has(.chatbot-table-response),
.chatbot-message-bubble-ai:has(.chatbot-comparison-response),
.chatbot-message-bubble-ai:has(.chatbot-salary-response) {
  max-width: 28rem;
  min-width: 24rem;
}

.chatbot-message-bubble:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.chatbot-message-bubble-user {
  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);
  color: var(--primary-white);
  /* Enhanced user message */
  border-bottom-right-radius: 0.25rem;
}

.chatbot-message-bubble-ai {
  background: var(--primary-white);
  color: var(--primary-blue);
  border: 1px solid var(--secondary-light-gray);
  /* Enhanced AI message */
  border-bottom-left-radius: 0.25rem;
}

.chatbot-message-text {
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
}

/* Markdown styling for chatbot messages */
.chatbot-message-text h4 {
  font-size: 1.1em;
  font-weight: bold;
  margin: 0.5em 0 0.25em 0;
  color: #1b2c5a;
}

.chatbot-message-text strong {
  font-weight: bold;
  color: #1b2c5a;
}

.chatbot-message-text ul {
  margin: 0.25em 0;
  padding-left: 1.2em;
}

.chatbot-message-text li {
  margin: 0.1em 0;
}

.chatbot-message-text p {
  margin: 0.25em 0;
}

.chatbot-message-text h1,
.chatbot-message-text h2,
.chatbot-message-text h3,
.chatbot-message-text h5,
.chatbot-message-text h6 {
  font-size: 1em;
  font-weight: bold;
  margin: 0.5em 0 0.25em 0;
  color: #1b2c5a;
}

.chatbot-message-text code {
  background: rgba(27, 44, 90, 0.1);
  padding: 0.1em 0.3em;
  border-radius: 0.25em;
  font-family: monospace;
  font-size: 0.9em;
}

.chatbot-message-text pre {
  background: rgba(27, 44, 90, 0.05);
  padding: 0.5em;
  border-radius: 0.5em;
  overflow-x: auto;
  margin: 0.5em 0;
}

.chatbot-message-text blockquote {
  border-left: 3px solid #1b2c5a;
  padding-left: 0.5em;
  margin: 0.5em 0;
  font-style: italic;
  color: #1b2c5a;
}

.chatbot-message-time {
  font-size: 0.75rem;
  margin-top: 0.5rem;
  opacity: 0.7;
  font-weight: 300;
}

.chatbot-message-time-user {
  color: var(--primary-white);
}

.chatbot-message-time-ai {
  color: var(--primary-blue);
}

/* Loading Animation */
.chatbot-loading {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem;
}

.chatbot-loading-dot {
  width: 0.6rem;
  height: 0.6rem;
  background: var(--primary-blue);
  border-radius: 50%;
  animation: chatbot-bounce 1.4s ease-in-out infinite both;
  /* Enhanced loading dots */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chatbot-loading-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.chatbot-loading-dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes chatbot-bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Input Container */
.chatbot-input-container {
  padding: 1rem;
  border-top: 1px solid var(--secondary-light-gray);
  background: linear-gradient(135deg, var(--primary-white), #fafbfc);
  border-radius: 0 0 var(--chatbot-border-radius) var(--chatbot-border-radius);
  /* Enhanced input container */
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  /* Ensure it doesn't overflow */
  flex-shrink: 0;
  min-height: 0;
}

.chatbot-input-wrapper {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  align-items: flex-end; /* Changed from center to flex-end for better mobile layout */
}

.chatbot-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 2px solid var(--secondary-light-gray);
  border-radius: var(--chatbot-border-radius-large);
  font-family: var(--font-body);
  font-size: 0.9rem;
  transition: all var(--chatbot-transition-medium);
  background: var(--primary-white);
  color: var(--primary-blue);
  /* Enhanced input styling */
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.chatbot-input:focus {
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1), inset 0 2px 4px rgba(0, 0, 0, 0.05);
  outline: none;
  transform: translateY(-1px);
}

.chatbot-input:disabled {
  background: var(--secondary-light-gray);
  cursor: not-allowed;
  opacity: 0.6;
}

/* Textarea specific styles */
.chatbot-textarea {
  resize: vertical;
  min-height: 3rem;
  max-height: 8rem;
  line-height: 1.5;
  font-family: inherit;
  /* Ensure textarea doesn't overflow container */
  width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.chatbot-textarea:focus {
  min-height: 4rem;
}

.chatbot-send-button {
  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);
  color: var(--primary-white);
  border: none;
  padding: 0.75rem;
  border-radius: var(--chatbot-border-radius-large);
  cursor: pointer;
  transition: all var(--chatbot-transition-medium);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 3rem;
  /* Enhanced send button */
  box-shadow: 0 2px 8px rgba(27, 44, 90, 0.2);
  position: relative;
  overflow: hidden;
}

.chatbot-send-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left var(--chatbot-transition-slow);
}

.chatbot-send-button:hover::before {
  left: 100%;
}

.chatbot-send-button:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--primary-gold), #e6b800);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(213, 163, 42, 0.3);
}

.chatbot-send-button:active:not(:disabled) {
  transform: translateY(0);
  transition: transform var(--chatbot-transition-fast);
}

.chatbot-send-button:disabled {
  background: var(--secondary-light-gray);
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.chatbot-send-icon {
  width: 1.1rem;
  height: 1.1rem;
  transition: transform var(--chatbot-transition-fast);
  transform: rotate(90deg);
}

.chatbot-send-button:hover:not(:disabled) .chatbot-send-icon {
  transform: scale(1.1) rotate(90deg);
}

.chatbot-input-hint {
  font-size: 0.75rem;
  color: var(--secondary-dark-gray);
  text-align: center;
  margin: 0;
  line-height: 1.3;
  font-weight: 300;
  /* Enhanced hint styling */
  opacity: 0.8;
  transition: opacity var(--chatbot-transition-fast);
}

.chatbot-input-hint:hover {
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .chatbot-container {
    right: 0.75rem;
    bottom: 4.5rem;
  }
  
  .chatbot-window {
    width: 28rem;
    height: 42rem;
    max-width: calc(100vw - 1.5rem);
    max-height: calc(100vh - 2rem);
  }
}

@media (max-width: 768px) {
  .chatbot-container {
    bottom: 5rem; /* Increased to avoid Job Postings bar overlap */
    right: 0.5rem;
    left: auto;
    /* Ensure button doesn't go below screen */
    min-height: 4rem;
  }
  
  .chatbot-window {
    width: calc(100vw - 1rem);
    height: calc(100vh - 2rem); /* Reduced to ensure full viewport visibility */
    max-width: calc(100vw - 1rem);
    max-height: calc(100vh - 2rem); /* Reduced to ensure full viewport visibility */
    border-radius: var(--chatbot-border-radius-small);
    /* Ensure window stays within viewport */
    position: fixed;
    top: 1rem;
    left: 0.5rem;
    right: 0.5rem;
    bottom: 1rem;
  }
  
  .chatbot-header {
    padding: 0.5rem;
    border-radius: var(--chatbot-border-radius-small) var(--chatbot-border-radius-small) 0 0;
  }
  
  .chatbot-messages {
    padding: 0.5rem;
    gap: 0.5rem;
  }
  
  .chatbot-input-container {
    padding: 0.5rem;
    border-radius: 0 0 var(--chatbot-border-radius-small) var(--chatbot-border-radius-small);
    /* Prevent zoom on input focus */
    position: sticky;
    bottom: 0;
    background: var(--primary-white);
    z-index: 10;
  }
  
  /* Prevent iOS zoom on input focus */
  .chatbot-input,
  .chatbot-textarea {
    font-size: 16px !important; /* Prevents zoom on iOS */
    transform: translateZ(0); /* Hardware acceleration */
  }
  
  /* Ensure Send button is always accessible */
  .chatbot-send-button {
    min-width: 44px; /* Minimum touch target size */
    min-height: 44px;
    flex-shrink: 0; /* Prevent shrinking */
  }
  
  .chatbot-input-wrapper {
    align-items: flex-end; /* Better alignment for mobile */
  }
  
  /* Mobile adjustments for wider table bubbles */
  .chatbot-message-bubble-ai:has(.chatbot-table-response),
  .chatbot-message-bubble-ai:has(.chatbot-comparison-response),
  .chatbot-message-bubble-ai:has(.chatbot-salary-response) {
    max-width: calc(100vw - 4rem);
    min-width: calc(100vw - 4rem);
  }
}

@media (max-width: 480px) {
  .chatbot-container {
    bottom: 3rem;
    right: 0.5rem;
    left: auto;
    /* Ensure doesn't go off bottom */
    max-height: calc(100vh - 3rem);
  }
  
  .chatbot-window {
    width: calc(100vw - 1rem);
    height: calc(100vh - 4.5rem);
    max-width: calc(100vw - 1rem);
    max-height: calc(100vh - 4.5rem);
    border-radius: var(--chatbot-border-radius-small);
  }
  
  .chatbot-toggle-button {
    padding: 0.875rem;
  }
  
  .chatbot-icon {
    width: 1.25rem;
    height: 1.25rem;
  }
  
  .chatbot-header {
    padding: 0.5rem;
  }
  
  .chatbot-messages {
    padding: 0.5rem;
    gap: 0.5rem;
  }
  
  .chatbot-input-container {
    padding: 0.5rem;
  }
  
  /* Smaller mobile adjustments for wider table bubbles */
  .chatbot-message-bubble-ai:has(.chatbot-table-response),
  .chatbot-message-bubble-ai:has(.chatbot-comparison-response),
  .chatbot-message-bubble-ai:has(.chatbot-salary-response) {
    max-width: calc(100vw - 2rem);
    min-width: calc(100vw - 2rem);
  }
}

@media (max-width: 360px) {
  .chatbot-container {
    bottom: 2.5rem;
    right: 0.5rem;
    left: auto;
    /* Safety: ensure stays within screen */
    max-height: calc(100vh - 2.5rem);
  }
  
  .chatbot-window {
    width: calc(100vw - 1rem);
    height: calc(100vh - 4rem);
    max-width: calc(100vw - 1rem);
    max-height: calc(100vh - 4rem);
    border-radius: 0.5rem;
  }
  
  .chatbot-toggle-button {
    padding: 0.75rem;
  }
  
  .chatbot-icon {
    width: 1rem;
    height: 1rem;
  }
  
  .chatbot-header {
    padding: 0.375rem;
  }
  
  .chatbot-messages {
    padding: 0.375rem;
    gap: 0.375rem;
  }
  
  .chatbot-input-container {
    padding: 0.375rem;
  }
  
  .chatbot-title {
    font-size: 0.875rem;
  }
  
  .chatbot-subtitle {
    font-size: 0.7rem;
  }
  
  /* Extra small mobile adjustments for wider table bubbles */
  .chatbot-message-bubble-ai:has(.chatbot-table-response),
  .chatbot-message-bubble-ai:has(.chatbot-comparison-response),
  .chatbot-message-bubble-ai:has(.chatbot-salary-response) {
    max-width: calc(100vw - 1rem);
    min-width: calc(100vw - 1rem);
  }
}

/* Enhanced Scrollbar Styling */
.chatbot-messages::-webkit-scrollbar {
  width: 8px;
}

.chatbot-messages::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

.chatbot-messages::-webkit-scrollbar-thumb {
  background: var(--secondary-light-gray);
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: content-box;
  -webkit-transition: background var(--chatbot-transition-fast);
  transition: background var(--chatbot-transition-fast);
}

.chatbot-messages::-webkit-scrollbar-thumb:hover {
  background: var(--secondary-dark-gray);
  background-clip: content-box;
}

.chatbot-messages::-webkit-scrollbar-corner {
  background: transparent;
}

/* Focus Management */
.chatbot-input:focus-visible {
  outline: 2px solid var(--primary-blue);
  outline-offset: 2px;
}

.chatbot-toggle-button:focus-visible,
.chatbot-header-button:focus-visible,
.chatbot-send-button:focus-visible {
  outline: 2px solid var(--primary-gold);
  outline-offset: 2px;
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  .chatbot-window {
    border: 2px solid var(--primary-blue);
  }
  
  .chatbot-message-bubble {
    border: 1px solid var(--primary-blue);
  }
}

/* Table Response Styling */
.chatbot-table-response {
  width: 100%;
  max-width: 100%;
  margin: 0.5rem 0;
}

.chatbot-table-header {
  margin-bottom: 0.75rem;
}

.chatbot-table-title {
  font-size: 1rem;
  font-weight: bold;
  color: var(--primary-blue);
  margin: 0 0 0.5rem 0;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid var(--primary-gold);
}

.chatbot-table-container {
  overflow-x: auto;
  border-radius: var(--chatbot-border-radius-small);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: var(--primary-white);
  border: 1px solid var(--secondary-light-gray);
}

.chatbot-response-table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--font-body);
  font-size: 0.85rem;
  margin: 0;
  background: var(--primary-white);
}

.chatbot-response-table th,
.chatbot-response-table td {
  padding: 0.75rem 0.5rem;
  text-align: left;
  border-bottom: 1px solid var(--secondary-light-gray);
  vertical-align: top;
}

.chatbot-response-table th {
  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);
  color: var(--primary-white);
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.chatbot-response-table td {
  color: var(--primary-blue);
  font-weight: 400;
  line-height: 1.4;
}

.chatbot-response-table tr:nth-child(even) {
  background-color: rgba(27, 44, 90, 0.02);
}

.chatbot-response-table tr:hover {
  background-color: rgba(27, 44, 90, 0.05);
  transition: background-color var(--chatbot-transition-fast);
}

.chatbot-response-table tr:last-child td {
  border-bottom: none;
}

/* Currency and numeric formatting */
.chatbot-currency {
  font-weight: 600;
  color: #059669;
}

.chatbot-percentage {
  font-weight: 600;
  color: #dc2626;
}

.chatbot-rank {
  font-weight: bold;
  color: var(--primary-gold);
  text-align: center;
}

.chatbot-soc-code {
  font-family: monospace;
  font-weight: 600;
  color: var(--primary-blue);
  background: rgba(27, 44, 90, 0.1);
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8em;
}

.chatbot-salary-difference {
  font-weight: 600;
  color: #059669;
  font-style: italic;
}

/* Insights and Recommendations Sections */
.chatbot-insights-section,
.chatbot-recommendations-section {
  margin-top: 1rem;
  padding: 0.75rem;
  background: linear-gradient(135deg, rgba(27, 44, 90, 0.05), rgba(27, 44, 90, 0.02));
  border-radius: var(--chatbot-border-radius-small);
  border-left: 4px solid var(--primary-gold);
}

.chatbot-insights-title,
.chatbot-recommendations-title {
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--primary-blue);
  margin: 0 0 0.5rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.chatbot-insights-title::before {
  content: '💡';
  font-size: 1rem;
}

.chatbot-recommendations-title::before {
  content: '🎯';
  font-size: 1rem;
}

.chatbot-insights-content,
.chatbot-recommendations-content {
  font-size: 0.85rem;
  color: var(--primary-blue);
  line-height: 1.5;
  margin: 0;
}

.chatbot-insights-content ul,
.chatbot-recommendations-content ul {
  margin: 0.5rem 0;
  padding-left: 1.25rem;
}

.chatbot-insights-content li,
.chatbot-recommendations-content li {
  margin: 0.25rem 0;
}

/* Response Footer */
.chatbot-response-footer {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--secondary-light-gray);
  text-align: center;
}

.chatbot-response-source {
  font-size: 0.75rem;
  color: var(--secondary-dark-gray);
  font-style: italic;
  margin: 0;
  opacity: 0.8;
}

.chatbot-response-source::before {
  content: '📊 ';
  margin-right: 0.25rem;
}

/* Comparison Response Specific Styling */
.chatbot-comparison-response .chatbot-response-table th {
  background: linear-gradient(135deg, var(--primary-gold), #e6b800);
  color: var(--primary-blue);
}

.chatbot-comparison-response .chatbot-response-table th:first-child {
  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);
  color: var(--primary-white);
}

/* Salary Response Specific Styling */
.chatbot-salary-response .chatbot-response-table th {
  background: linear-gradient(135deg, #059669, #047857);
  color: var(--primary-white);
}

/* Mobile Responsive Tables */
@media (max-width: 768px) {
  .chatbot-response-table {
    font-size: 0.8rem;
  }
  
  .chatbot-response-table th,
  .chatbot-response-table td {
    padding: 0.5rem 0.375rem;
  }
  
  .chatbot-table-container {
    border-radius: var(--chatbot-border-radius-small);
  }
  
  .chatbot-table-title {
    font-size: 0.9rem;
  }
  
  .chatbot-insights-section,
  .chatbot-recommendations-section {
    padding: 0.5rem;
    margin-top: 0.75rem;
  }
  
  .chatbot-insights-title,
  .chatbot-recommendations-title {
    font-size: 0.85rem;
  }
  
  .chatbot-insights-content,
  .chatbot-recommendations-content {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .chatbot-response-table {
    font-size: 0.75rem;
  }
  
  .chatbot-response-table th,
  .chatbot-response-table td {
    padding: 0.375rem 0.25rem;
  }
  
  .chatbot-table-title {
    font-size: 0.85rem;
  }
  
  .chatbot-insights-section,
  .chatbot-recommendations-section {
    padding: 0.375rem;
  }
  
  .chatbot-insights-title,
  .chatbot-recommendations-title {
    font-size: 0.8rem;
  }
  
  .chatbot-insights-content,
  .chatbot-recommendations-content {
    font-size: 0.75rem;
  }
}

/* Business and Job Posting Listings */
.chatbot-business-item,
.chatbot-job-item {
  background: linear-gradient(135deg, #f2e8d5 0%, #f9f1e3 100%);
  border: 1px solid #c1a27b;
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin: 0.5rem 0;
  font-size: 0.85rem;
  line-height: 1.5;
}

.chatbot-business-item strong,
.chatbot-job-item strong {
  color: #1b2c5a;
  font-weight: 600;
  display: block;
  margin-bottom: 0.25rem;
}

.chatbot-business-item a,
.chatbot-job-item a {
  color: #d5a32a;
  text-decoration: none;
  font-weight: 500;
}

.chatbot-business-item a:hover,
.chatbot-job-item a:hover {
  text-decoration: underline;
  color: #b8921e;
}

.chatbot-source-label {
  display: block;
  margin-top: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #c1a27b;
  font-size: 0.75rem;
  font-style: italic;
  color: #707070;
  text-align: center;
}

/* ====== ENHANCED RESPONSE TYPES STYLING ====== */

/* Job Postings Response */
.chatbot-job-postings-response {
  max-width: 100%;
}

.emoji-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  color: var(--primary-navy);
}

.response-subtitle {
  font-style: italic;
  color: #6B7280;
  margin: 0.5rem 0 1rem 0;
  font-size: 0.9rem;
}

.job-postings-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.job-posting-item {
  display: flex;
  gap: 1rem;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.job-posting-item:hover {
  border-color: var(--secondary-gold);
  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);
  transform: translateY(-2px);
}

.job-posting-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  background: var(--primary-navy);
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.85rem;
}

.job-posting-details {
  flex: 1 1;
}

.job-posting-title {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-navy);
}

.job-posting-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.75rem;
  font-size: 0.85rem;
  color: #6B7280;
}

.job-company,
.job-location {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.job-apply-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);
  color: white !important;
  text-decoration: none !important;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(213, 163, 42, 0.3);
  border: 2px solid #d5a32a;
}

.job-apply-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(213, 163, 42, 0.4);
  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);
  border-color: #f2c94c;
  color: white !important;
  text-decoration: none !important;
}

/* Business Listings Response */
.chatbot-business-listings-response {
  max-width: 100%;
}

.business-listings-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}

.business-listing-item {
  display: flex;
  gap: 1rem;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 1rem;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.business-listing-item:hover {
  border-color: #3B82F6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-2px);
}

.business-number {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;
  background: #3B82F6;
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.85rem;
}

.business-details {
  flex: 1 1;
}

.business-name {
  margin: 0 0 0.35rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-navy);
}

.business-location {
  margin: 0 0 0.5rem 0;
  font-size: 0.85rem;
  color: #6B7280;
}

.business-industry {
  margin-bottom: 0.75rem;
}

.industry-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: #EFF6FF;
  color: #3B82F6;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.business-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.business-phone,
.business-map-button {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  text-decoration: none !important;
  transition: all 0.2s ease;
  font-weight: 500;
}

.business-phone {
  background: #F3F4F6;
  color: #374151 !important;
  border: 1px solid #E5E7EB;
}

.business-phone:hover {
  background: #E5E7EB;
  color: #1F2937 !important;
  text-decoration: none !important;
}

.business-map-button {
  background: #3B82F6;
  color: white !important;
  border: 1px solid #3B82F6;
}

.business-map-button:hover {
  background: #2563EB;
  border-color: #2563EB;
  transform: translateY(-1px);
  color: white !important;
  text-decoration: none !important;
}

.naics-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background: #FEF3C7;
  color: #92400E;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

/* Wage Comparison Response */
.chatbot-wage-comparison-response {
  max-width: 100%;
}

.wage-comparison-container {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.occupation-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.occupation-name {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--primary-navy);
}

.soc-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: #F3F4F6;
  color: #374151;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

.wage-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.wage-card {
  background: linear-gradient(135deg, #F9FAFB, #F3F4F6);
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 1rem;
  text-align: center;
  transition: all 0.2s ease;
}

.wage-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.wage-card-highlight {
  background: linear-gradient(135deg, #DBEAFE, #BFDBFE);
  border-color: #3B82F6;
}

.wage-label {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6B7280;
  margin-bottom: 0.5rem;
  letter-spacing: 0.5px;
}

.wage-amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #10B981;
}

.wage-card-highlight .wage-amount {
  color: #3B82F6;
}

.wage-insights {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: #F9FAFB;
  border-radius: 8px;
}

.wage-insight-item {
  font-size: 0.85rem;
  color: #374151;
  line-height: 1.5;
}

.insight-positive {
  color: #10B981;
  font-weight: 600;
}

.wage-note {
  font-size: 0.8rem;
  color: #6B7280;
  padding: 0.75rem;
  background: #FFFBEB;
  border-left: 3px solid #F59E0B;
  border-radius: 4px;
}

/* Career Path Steps Response */
.chatbot-career-path-response {
  max-width: 100%;
}

.career-steps-timeline {
  position: relative;
  padding-left: 2rem;
}

.career-step-item {
  position: relative;
  margin-bottom: 2rem;
  padding-left: 2rem;
}

.career-step-item:last-child {
  margin-bottom: 0;
}

.step-number {
  position: absolute;
  left: -2rem;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, var(--primary-navy), #2d4a7c);
  color: white;
  border-radius: 50%;
  font-weight: 700;
  font-size: 1rem;
  box-shadow: 0 2px 8px rgba(27, 44, 90, 0.3);
  z-index: 2;
}

.step-content {
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.step-content:hover {
  border-color: var(--secondary-gold);
  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);
}

.step-title {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--primary-navy);
}

.step-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.step-detail {
  font-size: 0.85rem;
  color: #374151;
  line-height: 1.5;
}

.step-detail strong {
  color: var(--primary-navy);
  font-weight: 600;
  margin-right: 0.5rem;
}

.step-connector {
  position: absolute;
  left: -0.75rem;
  top: 2.5rem;
  bottom: -2rem;
  width: 2px;
  background: linear-gradient(to bottom, var(--primary-navy), #E2E8F0);
  z-index: 1;
}

/* Tip Box */
.chatbot-tip-box {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #EFF6FF;
  border-left: 4px solid #3B82F6;
  border-radius: 8px;
  margin-top: 1rem;
}

.tip-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}

.chatbot-tip-box p {
  margin: 0;
  font-size: 0.85rem;
  font-style: italic;
  color: #374151;
  line-height: 1.5;
}

/* Enhanced Links */
.chatbot-link {
  color: #3B82F6;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.chatbot-link:hover {
  color: #2563EB;
  text-decoration: underline;
}

/* Mobile Responsiveness for New Styles */
@media (max-width: 768px) {
  .emoji-title {
    font-size: 1.1rem;
  }

  .job-posting-item,
  .business-listing-item {
    flex-direction: column;
    gap: 0.75rem;
  }

  .job-posting-number,
  .business-number {
    align-self: flex-start;
  }

  .wage-columns {
    grid-template-columns: 1fr;
  }

  .wage-amount {
    font-size: 1.25rem;
  }

  .career-steps-timeline {
    padding-left: 1rem;
  }

  .career-step-item {
    padding-left: 1.5rem;
  }

  .step-number {
    left: -1rem;
    width: 2rem;
    height: 2rem;
    font-size: 0.85rem;
  }

  .step-connector {
    left: 0;
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  .chatbot-toggle-button,
  .chatbot-header-button,
  .chatbot-send-button,
  .chatbot-message-bubble,
  .chatbot-input,
  .chatbot-response-table tr {
    transition: none;
  }
  
  .chatbot-toggle-button:hover,
  .chatbot-header-button:hover,
  .chatbot-send-button:hover:not(:disabled) {
    transform: none;
  }
  
  .chatbot-loading-dot {
    animation: none;
    opacity: 0.7;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Chatbot.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D,2CAA2C;AAC3C;EACE,yDAAyD;EACzD,0DAA0D;EAC1D,0DAA0D;EAC1D,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,6BAA6B;EAC7B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,8CAA8C;AAC9C;EACE,WAAW,EAAE,0CAA0C;AACzD;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,YAAY,EAAE,4DAA4D;EAC1E,WAAW;EACX,aAAa,EAAE,kEAAkE;EACjF,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,2EAA2E;EAC3E,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,SAAS;EACT,UAAU;EACV,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,uCAAuC;EACvC,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;EACtD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uDAAuD;EACvD,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,2CAA2C;EAC3C,uCAAuC;EACvC,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,WAAW;AACX;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,aAAa;EACb,4EAA4E;EAC5E,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA+P;EAC/P,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,yCAAyC;EACzC,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,iDAAiD;EACjD,eAAe;EACf,8CAA8C;EAC9C,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yEAAyE;EACzE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,uDAAuD;EACvD,iDAAiD;EACjD,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;EACxC,8CAA8C;EAC9C,oCAAoC;EACpC,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;;;EAGE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,6CAA6C;EAC7C,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;EAKE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,wDAAwD;EACxD,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,iDAAiD;EACjD,kEAAkE;EAClE,4EAA4E;EAC5E,6BAA6B;EAC7B,0CAA0C;EAC1C,+BAA+B;EAC/B,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,qBAAqB,EAAE,6DAA6D;AACtF;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,6CAA6C;EAC7C,iDAAiD;EACjD,6BAA6B;EAC7B,iBAAiB;EACjB,gDAAgD;EAChD,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,gFAAgF;EAChF,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;EAC/C,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;EACjD,eAAe;EACf,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oDAAoD;EACpD,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,YAAY,EAAE,gDAAgD;IAC9D,aAAa;IACb,UAAU;IACV,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B,EAAE,+CAA+C;IAC3E,6BAA6B;IAC7B,8BAA8B,EAAE,+CAA+C;IAC/E,iDAAiD;IACjD,wCAAwC;IACxC,eAAe;IACf,SAAS;IACT,YAAY;IACZ,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,wFAAwF;EAC1F;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,wFAAwF;IACxF,gCAAgC;IAChC,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,WAAW;EACb;;EAEA,oCAAoC;EACpC;;IAEE,0BAA0B,EAAE,yBAAyB;IACrD,wBAAwB,EAAE,0BAA0B;EACtD;;EAEA,4CAA4C;EAC5C;IACE,eAAe,EAAE,8BAA8B;IAC/C,gBAAgB;IAChB,cAAc,EAAE,sBAAsB;EACxC;;EAEA;IACE,qBAAqB,EAAE,gCAAgC;EACzD;;EAEA,+CAA+C;EAC/C;;;IAGE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,iDAAiD;EACnD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA,uDAAuD;EACvD;;;IAGE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,cAAc;IACd,aAAa;IACb,UAAU;IACV,uCAAuC;IACvC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,2DAA2D;EAC3D;;;IAGE,6BAA6B;IAC7B,6BAA6B;EAC/B;AACF;;AAEA,+BAA+B;AAC/B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,6DAAqD;EAArD,qDAAqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;EAGE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,wCAAwC;EACxC,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iCAAiC;EACjC,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,mFAAmF;EACnF,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,iEAAiE;EACjE,0BAA0B;AAC5B;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;AACtC;;EAEE,6DAA6D;EAC7D,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kDAAkD;;AAElD,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;EAC7D,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,iEAAiE;EACjE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,aAAa;EACb,UAAU;EACV,oEAAoE;EACpE,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,OAAO;EACT;AACF;;AAEA,2BAA2B;AAC3B;EACE;;;;;;IAME,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* Chatbot Component Styles - Forward Sumner Brand Compliant */\n\n/* CSS Custom Properties for easy theming */\n:root {\n  --chatbot-shadow-light: 0 4px 12px rgba(27, 44, 90, 0.15);\n  --chatbot-shadow-medium: 0 6px 20px rgba(27, 44, 90, 0.25);\n  --chatbot-shadow-heavy: 0 20px 40px rgba(27, 44, 90, 0.25);\n  --chatbot-transition-fast: 0.2s ease;\n  --chatbot-transition-medium: 0.3s ease;\n  --chatbot-transition-slow: 0.5s ease;\n  --chatbot-border-radius: 1rem;\n  --chatbot-border-radius-small: 0.75rem;\n  --chatbot-border-radius-large: 1.5rem;\n}\n\n/* Dynamic z-index for tooltip compatibility */\n.chatbot-container.chatbot-low-zindex {\n  z-index: 10; /* Lower than tooltips when they're open */\n}\n\n/* Main Container */\n.chatbot-container {\n  position: fixed;\n  bottom: 6rem; /* Moved up further to avoid overlap with Job Postings bar */\n  right: 1rem;\n  z-index: 9999; /* Highest z-index to ensure chatbot appears on top of all pages */\n  font-family: var(--font-body);\n  /* Ensure it's above other elements */\n  isolation: isolate;\n  /* CRITICAL: Ensure entire container stays within ALL viewport boundaries */\n  max-width: calc(100vw - 2rem);\n  max-height: calc(100vh - 7rem);\n  /* Prevent overflow on all sides */\n  top: auto;\n  left: auto;\n  /* Ensure minimum spacing from edges */\n}\n\n/* Chat Toggle Button */\n.chatbot-toggle-button {\n  background: var(--primary-blue);\n  color: var(--primary-white);\n  border: none;\n  border-radius: 50%;\n  padding: 1rem;\n  cursor: pointer;\n  box-shadow: var(--chatbot-shadow-light);\n  transition: all var(--chatbot-transition-medium);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Improved hover effects */\n  position: relative;\n  overflow: hidden;\n  /* CRITICAL: Ensure button doesn't overflow viewport */\n  width: 3.75rem;\n  height: 3.75rem;\n  max-width: 3.75rem;\n  max-height: 3.75rem;\n  /* Prevent any size changes that could cause overflow */\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.chatbot-toggle-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left var(--chatbot-transition-slow);\n}\n\n.chatbot-toggle-button:hover::before {\n  left: 100%;\n}\n\n.chatbot-toggle-button:hover {\n  background: var(--primary-gold);\n  transform: scale(1.1) rotate(5deg);\n  box-shadow: var(--chatbot-shadow-medium);\n}\n\n.chatbot-toggle-button:active {\n  transform: scale(0.95);\n  transition: transform var(--chatbot-transition-fast);\n}\n\n.chatbot-toggle-button.chatbot-minimized {\n  padding: 0.75rem;\n  animation: chatbot-pulse 2s infinite;\n}\n\n@keyframes chatbot-pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n.chatbot-icon {\n  width: 1.75rem;\n  height: 1.75rem;\n  transition: transform var(--chatbot-transition-medium);\n}\n\n.chatbot-toggle-button:hover .chatbot-icon {\n  transform: scale(1.1);\n}\n\n/* Chat Window */\n.chatbot-window {\n  background: var(--primary-white);\n  border-radius: var(--chatbot-border-radius);\n  box-shadow: var(--chatbot-shadow-heavy);\n  border: 1px solid var(--secondary-light-gray);\n  width: 32rem;\n  height: 45rem;\n  /* CRITICAL: Never exceed viewport boundaries on ANY side */\n  max-width: calc(100vw - 2rem);\n  max-height: calc(100vh - 7rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  /* Smooth entrance animation */\n  animation: chatbot-slide-up 0.3s ease-out;\n  /* Glass morphism effect */\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.95);\n  /* Ensure it stays within viewport */\n  position: relative;\n  /* Prevent all overflow */\n  box-sizing: border-box;\n  margin-left: auto;\n  margin-right: 0;\n  /* Additional safety: prevent bottom overflow */\n  margin-bottom: 0;\n}\n\n@keyframes chatbot-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Header */\n.chatbot-header {\n  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);\n  color: var(--primary-white);\n  padding: 1rem;\n  border-radius: var(--chatbot-border-radius) var(--chatbot-border-radius) 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  /* Enhanced header with subtle pattern */\n  position: relative;\n  overflow: hidden;\n}\n\n.chatbot-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='3' cy='3' r='1'/%3E%3Ccircle cx='13' cy='13' r='1'/%3E%3C/g%3E%3C/svg%3E\");\n  pointer-events: none;\n}\n\n.chatbot-header-content {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  position: relative;\n  z-index: 1;\n}\n\n.chatbot-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  background: var(--primary-white);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Enhanced avatar with shadow */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  transition: all var(--chatbot-transition-medium);\n}\n\n.chatbot-avatar:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.chatbot-avatar-text {\n  color: var(--primary-blue);\n  font-weight: bold;\n  font-size: 1rem;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.chatbot-header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.chatbot-title {\n  font-family: var(--font-heading);\n  font-weight: 700;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.2;\n  color: var(--primary-white);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.chatbot-subtitle {\n  font-size: 0.8rem;\n  margin: 0;\n  opacity: 0.9;\n  line-height: 1.2;\n  font-weight: 300;\n}\n\n.chatbot-header-actions {\n  display: flex;\n  gap: 0.5rem;\n  position: relative;\n  z-index: 1;\n}\n\n.chatbot-header-button {\n  background: none;\n  border: none;\n  color: var(--primary-white);\n  padding: 0.5rem;\n  border-radius: var(--chatbot-border-radius-small);\n  cursor: pointer;\n  transition: all var(--chatbot-transition-fast);\n  opacity: 0.8;\n  /* Enhanced button styling */\n  position: relative;\n  overflow: hidden;\n}\n\n.chatbot-header-button::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  transition: all var(--chatbot-transition-fast);\n  transform: translate(-50%, -50%);\n}\n\n.chatbot-header-button:hover::before {\n  width: 100%;\n  height: 100%;\n}\n\n.chatbot-header-button:hover {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.chatbot-header-icon {\n  width: 1.1rem;\n  height: 1.1rem;\n  transition: transform var(--chatbot-transition-fast);\n}\n\n.chatbot-header-button:hover .chatbot-header-icon {\n  transform: scale(1.2);\n}\n\n/* Messages */\n.chatbot-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 1rem;\n  background: linear-gradient(135deg, var(--secondary-light-gray), #f8f9fa);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  /* Enhanced scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: var(--secondary-dark-gray) transparent;\n  /* Ensure content doesn't overflow horizontally */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.chatbot-message {\n  display: flex;\n  animation: chatbot-message-fade-in 0.3s ease-out;\n}\n\n@keyframes chatbot-message-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.chatbot-message-user {\n  justify-content: flex-end;\n}\n\n.chatbot-message-ai {\n  justify-content: flex-start;\n}\n\n.chatbot-message-bubble {\n  max-width: 18rem;\n  padding: 0.75rem 1rem;\n  border-radius: var(--chatbot-border-radius-large);\n  position: relative;\n  /* Enhanced bubble styling */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all var(--chatbot-transition-fast);\n  /* Ensure content doesn't overflow */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  overflow: hidden;\n}\n\n/* Wider bubble for AI responses with tables */\n.chatbot-message-bubble-ai:has(.chatbot-table-response),\n.chatbot-message-bubble-ai:has(.chatbot-comparison-response),\n.chatbot-message-bubble-ai:has(.chatbot-salary-response) {\n  max-width: 28rem;\n  min-width: 24rem;\n}\n\n.chatbot-message-bubble:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.chatbot-message-bubble-user {\n  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);\n  color: var(--primary-white);\n  /* Enhanced user message */\n  border-bottom-right-radius: 0.25rem;\n}\n\n.chatbot-message-bubble-ai {\n  background: var(--primary-white);\n  color: var(--primary-blue);\n  border: 1px solid var(--secondary-light-gray);\n  /* Enhanced AI message */\n  border-bottom-left-radius: 0.25rem;\n}\n\n.chatbot-message-text {\n  font-size: 0.9rem;\n  margin: 0;\n  line-height: 1.5;\n  font-weight: 400;\n}\n\n/* Markdown styling for chatbot messages */\n.chatbot-message-text h4 {\n  font-size: 1.1em;\n  font-weight: bold;\n  margin: 0.5em 0 0.25em 0;\n  color: #1b2c5a;\n}\n\n.chatbot-message-text strong {\n  font-weight: bold;\n  color: #1b2c5a;\n}\n\n.chatbot-message-text ul {\n  margin: 0.25em 0;\n  padding-left: 1.2em;\n}\n\n.chatbot-message-text li {\n  margin: 0.1em 0;\n}\n\n.chatbot-message-text p {\n  margin: 0.25em 0;\n}\n\n.chatbot-message-text h1,\n.chatbot-message-text h2,\n.chatbot-message-text h3,\n.chatbot-message-text h5,\n.chatbot-message-text h6 {\n  font-size: 1em;\n  font-weight: bold;\n  margin: 0.5em 0 0.25em 0;\n  color: #1b2c5a;\n}\n\n.chatbot-message-text code {\n  background: rgba(27, 44, 90, 0.1);\n  padding: 0.1em 0.3em;\n  border-radius: 0.25em;\n  font-family: monospace;\n  font-size: 0.9em;\n}\n\n.chatbot-message-text pre {\n  background: rgba(27, 44, 90, 0.05);\n  padding: 0.5em;\n  border-radius: 0.5em;\n  overflow-x: auto;\n  margin: 0.5em 0;\n}\n\n.chatbot-message-text blockquote {\n  border-left: 3px solid #1b2c5a;\n  padding-left: 0.5em;\n  margin: 0.5em 0;\n  font-style: italic;\n  color: #1b2c5a;\n}\n\n.chatbot-message-time {\n  font-size: 0.75rem;\n  margin-top: 0.5rem;\n  opacity: 0.7;\n  font-weight: 300;\n}\n\n.chatbot-message-time-user {\n  color: var(--primary-white);\n}\n\n.chatbot-message-time-ai {\n  color: var(--primary-blue);\n}\n\n/* Loading Animation */\n.chatbot-loading {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  padding: 0.5rem;\n}\n\n.chatbot-loading-dot {\n  width: 0.6rem;\n  height: 0.6rem;\n  background: var(--primary-blue);\n  border-radius: 50%;\n  animation: chatbot-bounce 1.4s ease-in-out infinite both;\n  /* Enhanced loading dots */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.chatbot-loading-dot:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.chatbot-loading-dot:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes chatbot-bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Input Container */\n.chatbot-input-container {\n  padding: 1rem;\n  border-top: 1px solid var(--secondary-light-gray);\n  background: linear-gradient(135deg, var(--primary-white), #fafbfc);\n  border-radius: 0 0 var(--chatbot-border-radius) var(--chatbot-border-radius);\n  /* Enhanced input container */\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);\n  /* Ensure it doesn't overflow */\n  flex-shrink: 0;\n  min-height: 0;\n}\n\n.chatbot-input-wrapper {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n  align-items: flex-end; /* Changed from center to flex-end for better mobile layout */\n}\n\n.chatbot-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--secondary-light-gray);\n  border-radius: var(--chatbot-border-radius-large);\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  transition: all var(--chatbot-transition-medium);\n  background: var(--primary-white);\n  color: var(--primary-blue);\n  /* Enhanced input styling */\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.chatbot-input:focus {\n  border-color: var(--primary-blue);\n  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1), inset 0 2px 4px rgba(0, 0, 0, 0.05);\n  outline: none;\n  transform: translateY(-1px);\n}\n\n.chatbot-input:disabled {\n  background: var(--secondary-light-gray);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Textarea specific styles */\n.chatbot-textarea {\n  resize: vertical;\n  min-height: 3rem;\n  max-height: 8rem;\n  line-height: 1.5;\n  font-family: inherit;\n  /* Ensure textarea doesn't overflow container */\n  width: 100%;\n  box-sizing: border-box;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n\n.chatbot-textarea:focus {\n  min-height: 4rem;\n}\n\n.chatbot-send-button {\n  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);\n  color: var(--primary-white);\n  border: none;\n  padding: 0.75rem;\n  border-radius: var(--chatbot-border-radius-large);\n  cursor: pointer;\n  transition: all var(--chatbot-transition-medium);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 3rem;\n  /* Enhanced send button */\n  box-shadow: 0 2px 8px rgba(27, 44, 90, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.chatbot-send-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  transition: left var(--chatbot-transition-slow);\n}\n\n.chatbot-send-button:hover::before {\n  left: 100%;\n}\n\n.chatbot-send-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--primary-gold), #e6b800);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(213, 163, 42, 0.3);\n}\n\n.chatbot-send-button:active:not(:disabled) {\n  transform: translateY(0);\n  transition: transform var(--chatbot-transition-fast);\n}\n\n.chatbot-send-button:disabled {\n  background: var(--secondary-light-gray);\n  cursor: not-allowed;\n  opacity: 0.6;\n  transform: none;\n}\n\n.chatbot-send-icon {\n  width: 1.1rem;\n  height: 1.1rem;\n  transition: transform var(--chatbot-transition-fast);\n  transform: rotate(90deg);\n}\n\n.chatbot-send-button:hover:not(:disabled) .chatbot-send-icon {\n  transform: scale(1.1) rotate(90deg);\n}\n\n.chatbot-input-hint {\n  font-size: 0.75rem;\n  color: var(--secondary-dark-gray);\n  text-align: center;\n  margin: 0;\n  line-height: 1.3;\n  font-weight: 300;\n  /* Enhanced hint styling */\n  opacity: 0.8;\n  transition: opacity var(--chatbot-transition-fast);\n}\n\n.chatbot-input-hint:hover {\n  opacity: 1;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .chatbot-container {\n    right: 0.75rem;\n    bottom: 4.5rem;\n  }\n  \n  .chatbot-window {\n    width: 28rem;\n    height: 42rem;\n    max-width: calc(100vw - 1.5rem);\n    max-height: calc(100vh - 2rem);\n  }\n}\n\n@media (max-width: 768px) {\n  .chatbot-container {\n    bottom: 5rem; /* Increased to avoid Job Postings bar overlap */\n    right: 0.5rem;\n    left: auto;\n    /* Ensure button doesn't go below screen */\n    min-height: 4rem;\n  }\n  \n  .chatbot-window {\n    width: calc(100vw - 1rem);\n    height: calc(100vh - 2rem); /* Reduced to ensure full viewport visibility */\n    max-width: calc(100vw - 1rem);\n    max-height: calc(100vh - 2rem); /* Reduced to ensure full viewport visibility */\n    border-radius: var(--chatbot-border-radius-small);\n    /* Ensure window stays within viewport */\n    position: fixed;\n    top: 1rem;\n    left: 0.5rem;\n    right: 0.5rem;\n    bottom: 1rem;\n  }\n  \n  .chatbot-header {\n    padding: 0.5rem;\n    border-radius: var(--chatbot-border-radius-small) var(--chatbot-border-radius-small) 0 0;\n  }\n  \n  .chatbot-messages {\n    padding: 0.5rem;\n    gap: 0.5rem;\n  }\n  \n  .chatbot-input-container {\n    padding: 0.5rem;\n    border-radius: 0 0 var(--chatbot-border-radius-small) var(--chatbot-border-radius-small);\n    /* Prevent zoom on input focus */\n    position: sticky;\n    bottom: 0;\n    background: var(--primary-white);\n    z-index: 10;\n  }\n  \n  /* Prevent iOS zoom on input focus */\n  .chatbot-input,\n  .chatbot-textarea {\n    font-size: 16px !important; /* Prevents zoom on iOS */\n    transform: translateZ(0); /* Hardware acceleration */\n  }\n  \n  /* Ensure Send button is always accessible */\n  .chatbot-send-button {\n    min-width: 44px; /* Minimum touch target size */\n    min-height: 44px;\n    flex-shrink: 0; /* Prevent shrinking */\n  }\n  \n  .chatbot-input-wrapper {\n    align-items: flex-end; /* Better alignment for mobile */\n  }\n  \n  /* Mobile adjustments for wider table bubbles */\n  .chatbot-message-bubble-ai:has(.chatbot-table-response),\n  .chatbot-message-bubble-ai:has(.chatbot-comparison-response),\n  .chatbot-message-bubble-ai:has(.chatbot-salary-response) {\n    max-width: calc(100vw - 4rem);\n    min-width: calc(100vw - 4rem);\n  }\n}\n\n@media (max-width: 480px) {\n  .chatbot-container {\n    bottom: 3rem;\n    right: 0.5rem;\n    left: auto;\n    /* Ensure doesn't go off bottom */\n    max-height: calc(100vh - 3rem);\n  }\n  \n  .chatbot-window {\n    width: calc(100vw - 1rem);\n    height: calc(100vh - 4.5rem);\n    max-width: calc(100vw - 1rem);\n    max-height: calc(100vh - 4.5rem);\n    border-radius: var(--chatbot-border-radius-small);\n  }\n  \n  .chatbot-toggle-button {\n    padding: 0.875rem;\n  }\n  \n  .chatbot-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  \n  .chatbot-header {\n    padding: 0.5rem;\n  }\n  \n  .chatbot-messages {\n    padding: 0.5rem;\n    gap: 0.5rem;\n  }\n  \n  .chatbot-input-container {\n    padding: 0.5rem;\n  }\n  \n  /* Smaller mobile adjustments for wider table bubbles */\n  .chatbot-message-bubble-ai:has(.chatbot-table-response),\n  .chatbot-message-bubble-ai:has(.chatbot-comparison-response),\n  .chatbot-message-bubble-ai:has(.chatbot-salary-response) {\n    max-width: calc(100vw - 2rem);\n    min-width: calc(100vw - 2rem);\n  }\n}\n\n@media (max-width: 360px) {\n  .chatbot-container {\n    bottom: 2.5rem;\n    right: 0.5rem;\n    left: auto;\n    /* Safety: ensure stays within screen */\n    max-height: calc(100vh - 2.5rem);\n  }\n  \n  .chatbot-window {\n    width: calc(100vw - 1rem);\n    height: calc(100vh - 4rem);\n    max-width: calc(100vw - 1rem);\n    max-height: calc(100vh - 4rem);\n    border-radius: 0.5rem;\n  }\n  \n  .chatbot-toggle-button {\n    padding: 0.75rem;\n  }\n  \n  .chatbot-icon {\n    width: 1rem;\n    height: 1rem;\n  }\n  \n  .chatbot-header {\n    padding: 0.375rem;\n  }\n  \n  .chatbot-messages {\n    padding: 0.375rem;\n    gap: 0.375rem;\n  }\n  \n  .chatbot-input-container {\n    padding: 0.375rem;\n  }\n  \n  .chatbot-title {\n    font-size: 0.875rem;\n  }\n  \n  .chatbot-subtitle {\n    font-size: 0.7rem;\n  }\n  \n  /* Extra small mobile adjustments for wider table bubbles */\n  .chatbot-message-bubble-ai:has(.chatbot-table-response),\n  .chatbot-message-bubble-ai:has(.chatbot-comparison-response),\n  .chatbot-message-bubble-ai:has(.chatbot-salary-response) {\n    max-width: calc(100vw - 1rem);\n    min-width: calc(100vw - 1rem);\n  }\n}\n\n/* Enhanced Scrollbar Styling */\n.chatbot-messages::-webkit-scrollbar {\n  width: 8px;\n}\n\n.chatbot-messages::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 4px;\n}\n\n.chatbot-messages::-webkit-scrollbar-thumb {\n  background: var(--secondary-light-gray);\n  border-radius: 4px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n  transition: background var(--chatbot-transition-fast);\n}\n\n.chatbot-messages::-webkit-scrollbar-thumb:hover {\n  background: var(--secondary-dark-gray);\n  background-clip: content-box;\n}\n\n.chatbot-messages::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* Focus Management */\n.chatbot-input:focus-visible {\n  outline: 2px solid var(--primary-blue);\n  outline-offset: 2px;\n}\n\n.chatbot-toggle-button:focus-visible,\n.chatbot-header-button:focus-visible,\n.chatbot-send-button:focus-visible {\n  outline: 2px solid var(--primary-gold);\n  outline-offset: 2px;\n}\n\n/* High Contrast Mode Support */\n@media (prefers-contrast: high) {\n  .chatbot-window {\n    border: 2px solid var(--primary-blue);\n  }\n  \n  .chatbot-message-bubble {\n    border: 1px solid var(--primary-blue);\n  }\n}\n\n/* Table Response Styling */\n.chatbot-table-response {\n  width: 100%;\n  max-width: 100%;\n  margin: 0.5rem 0;\n}\n\n.chatbot-table-header {\n  margin-bottom: 0.75rem;\n}\n\n.chatbot-table-title {\n  font-size: 1rem;\n  font-weight: bold;\n  color: var(--primary-blue);\n  margin: 0 0 0.5rem 0;\n  padding-bottom: 0.25rem;\n  border-bottom: 2px solid var(--primary-gold);\n}\n\n.chatbot-table-container {\n  overflow-x: auto;\n  border-radius: var(--chatbot-border-radius-small);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  background: var(--primary-white);\n  border: 1px solid var(--secondary-light-gray);\n}\n\n.chatbot-response-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: var(--font-body);\n  font-size: 0.85rem;\n  margin: 0;\n  background: var(--primary-white);\n}\n\n.chatbot-response-table th,\n.chatbot-response-table td {\n  padding: 0.75rem 0.5rem;\n  text-align: left;\n  border-bottom: 1px solid var(--secondary-light-gray);\n  vertical-align: top;\n}\n\n.chatbot-response-table th {\n  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);\n  color: var(--primary-white);\n  font-weight: 600;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.chatbot-response-table td {\n  color: var(--primary-blue);\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.chatbot-response-table tr:nth-child(even) {\n  background-color: rgba(27, 44, 90, 0.02);\n}\n\n.chatbot-response-table tr:hover {\n  background-color: rgba(27, 44, 90, 0.05);\n  transition: background-color var(--chatbot-transition-fast);\n}\n\n.chatbot-response-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Currency and numeric formatting */\n.chatbot-currency {\n  font-weight: 600;\n  color: #059669;\n}\n\n.chatbot-percentage {\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.chatbot-rank {\n  font-weight: bold;\n  color: var(--primary-gold);\n  text-align: center;\n}\n\n.chatbot-soc-code {\n  font-family: monospace;\n  font-weight: 600;\n  color: var(--primary-blue);\n  background: rgba(27, 44, 90, 0.1);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.8em;\n}\n\n.chatbot-salary-difference {\n  font-weight: 600;\n  color: #059669;\n  font-style: italic;\n}\n\n/* Insights and Recommendations Sections */\n.chatbot-insights-section,\n.chatbot-recommendations-section {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background: linear-gradient(135deg, rgba(27, 44, 90, 0.05), rgba(27, 44, 90, 0.02));\n  border-radius: var(--chatbot-border-radius-small);\n  border-left: 4px solid var(--primary-gold);\n}\n\n.chatbot-insights-title,\n.chatbot-recommendations-title {\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: var(--primary-blue);\n  margin: 0 0 0.5rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.chatbot-insights-title::before {\n  content: '💡';\n  font-size: 1rem;\n}\n\n.chatbot-recommendations-title::before {\n  content: '🎯';\n  font-size: 1rem;\n}\n\n.chatbot-insights-content,\n.chatbot-recommendations-content {\n  font-size: 0.85rem;\n  color: var(--primary-blue);\n  line-height: 1.5;\n  margin: 0;\n}\n\n.chatbot-insights-content ul,\n.chatbot-recommendations-content ul {\n  margin: 0.5rem 0;\n  padding-left: 1.25rem;\n}\n\n.chatbot-insights-content li,\n.chatbot-recommendations-content li {\n  margin: 0.25rem 0;\n}\n\n/* Response Footer */\n.chatbot-response-footer {\n  margin-top: 1rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--secondary-light-gray);\n  text-align: center;\n}\n\n.chatbot-response-source {\n  font-size: 0.75rem;\n  color: var(--secondary-dark-gray);\n  font-style: italic;\n  margin: 0;\n  opacity: 0.8;\n}\n\n.chatbot-response-source::before {\n  content: '📊 ';\n  margin-right: 0.25rem;\n}\n\n/* Comparison Response Specific Styling */\n.chatbot-comparison-response .chatbot-response-table th {\n  background: linear-gradient(135deg, var(--primary-gold), #e6b800);\n  color: var(--primary-blue);\n}\n\n.chatbot-comparison-response .chatbot-response-table th:first-child {\n  background: linear-gradient(135deg, var(--primary-blue), #2a3f7a);\n  color: var(--primary-white);\n}\n\n/* Salary Response Specific Styling */\n.chatbot-salary-response .chatbot-response-table th {\n  background: linear-gradient(135deg, #059669, #047857);\n  color: var(--primary-white);\n}\n\n/* Mobile Responsive Tables */\n@media (max-width: 768px) {\n  .chatbot-response-table {\n    font-size: 0.8rem;\n  }\n  \n  .chatbot-response-table th,\n  .chatbot-response-table td {\n    padding: 0.5rem 0.375rem;\n  }\n  \n  .chatbot-table-container {\n    border-radius: var(--chatbot-border-radius-small);\n  }\n  \n  .chatbot-table-title {\n    font-size: 0.9rem;\n  }\n  \n  .chatbot-insights-section,\n  .chatbot-recommendations-section {\n    padding: 0.5rem;\n    margin-top: 0.75rem;\n  }\n  \n  .chatbot-insights-title,\n  .chatbot-recommendations-title {\n    font-size: 0.85rem;\n  }\n  \n  .chatbot-insights-content,\n  .chatbot-recommendations-content {\n    font-size: 0.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .chatbot-response-table {\n    font-size: 0.75rem;\n  }\n  \n  .chatbot-response-table th,\n  .chatbot-response-table td {\n    padding: 0.375rem 0.25rem;\n  }\n  \n  .chatbot-table-title {\n    font-size: 0.85rem;\n  }\n  \n  .chatbot-insights-section,\n  .chatbot-recommendations-section {\n    padding: 0.375rem;\n  }\n  \n  .chatbot-insights-title,\n  .chatbot-recommendations-title {\n    font-size: 0.8rem;\n  }\n  \n  .chatbot-insights-content,\n  .chatbot-recommendations-content {\n    font-size: 0.75rem;\n  }\n}\n\n/* Business and Job Posting Listings */\n.chatbot-business-item,\n.chatbot-job-item {\n  background: linear-gradient(135deg, #f2e8d5 0%, #f9f1e3 100%);\n  border: 1px solid #c1a27b;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  margin: 0.5rem 0;\n  font-size: 0.85rem;\n  line-height: 1.5;\n}\n\n.chatbot-business-item strong,\n.chatbot-job-item strong {\n  color: #1b2c5a;\n  font-weight: 600;\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.chatbot-business-item a,\n.chatbot-job-item a {\n  color: #d5a32a;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.chatbot-business-item a:hover,\n.chatbot-job-item a:hover {\n  text-decoration: underline;\n  color: #b8921e;\n}\n\n.chatbot-source-label {\n  display: block;\n  margin-top: 0.75rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid #c1a27b;\n  font-size: 0.75rem;\n  font-style: italic;\n  color: #707070;\n  text-align: center;\n}\n\n/* ====== ENHANCED RESPONSE TYPES STYLING ====== */\n\n/* Job Postings Response */\n.chatbot-job-postings-response {\n  max-width: 100%;\n}\n\n.emoji-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0 0 1rem 0;\n  color: var(--primary-navy);\n}\n\n.response-subtitle {\n  font-style: italic;\n  color: #6B7280;\n  margin: 0.5rem 0 1rem 0;\n  font-size: 0.9rem;\n}\n\n.job-postings-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.job-posting-item {\n  display: flex;\n  gap: 1rem;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 1rem;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.job-posting-item:hover {\n  border-color: var(--secondary-gold);\n  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);\n  transform: translateY(-2px);\n}\n\n.job-posting-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2rem;\n  height: 2rem;\n  background: var(--primary-navy);\n  color: white;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.job-posting-details {\n  flex: 1;\n}\n\n.job-posting-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--primary-navy);\n}\n\n.job-posting-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 0.75rem;\n  font-size: 0.85rem;\n  color: #6B7280;\n}\n\n.job-company,\n.job-location {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.job-apply-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);\n  color: white !important;\n  text-decoration: none !important;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(213, 163, 42, 0.3);\n  border: 2px solid #d5a32a;\n}\n\n.job-apply-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(213, 163, 42, 0.4);\n  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);\n  border-color: #f2c94c;\n  color: white !important;\n  text-decoration: none !important;\n}\n\n/* Business Listings Response */\n.chatbot-business-listings-response {\n  max-width: 100%;\n}\n\n.business-listings-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.business-listing-item {\n  display: flex;\n  gap: 1rem;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 1rem;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.business-listing-item:hover {\n  border-color: #3B82F6;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n  transform: translateY(-2px);\n}\n\n.business-number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2rem;\n  height: 2rem;\n  background: #3B82F6;\n  color: white;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.business-details {\n  flex: 1;\n}\n\n.business-name {\n  margin: 0 0 0.35rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--primary-navy);\n}\n\n.business-location {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.85rem;\n  color: #6B7280;\n}\n\n.business-industry {\n  margin-bottom: 0.75rem;\n}\n\n.industry-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background: #EFF6FF;\n  color: #3B82F6;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.business-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.business-phone,\n.business-map-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  text-decoration: none !important;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.business-phone {\n  background: #F3F4F6;\n  color: #374151 !important;\n  border: 1px solid #E5E7EB;\n}\n\n.business-phone:hover {\n  background: #E5E7EB;\n  color: #1F2937 !important;\n  text-decoration: none !important;\n}\n\n.business-map-button {\n  background: #3B82F6;\n  color: white !important;\n  border: 1px solid #3B82F6;\n}\n\n.business-map-button:hover {\n  background: #2563EB;\n  border-color: #2563EB;\n  transform: translateY(-1px);\n  color: white !important;\n  text-decoration: none !important;\n}\n\n.naics-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  background: #FEF3C7;\n  color: #92400E;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  font-family: 'Courier New', monospace;\n}\n\n/* Wage Comparison Response */\n.chatbot-wage-comparison-response {\n  max-width: 100%;\n}\n\n.wage-comparison-container {\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.occupation-info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.occupation-name {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--primary-navy);\n}\n\n.soc-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background: #F3F4F6;\n  color: #374151;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-family: 'Courier New', monospace;\n}\n\n.wage-columns {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.wage-card {\n  background: linear-gradient(135deg, #F9FAFB, #F3F4F6);\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 1rem;\n  text-align: center;\n  transition: all 0.2s ease;\n}\n\n.wage-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.wage-card-highlight {\n  background: linear-gradient(135deg, #DBEAFE, #BFDBFE);\n  border-color: #3B82F6;\n}\n\n.wage-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #6B7280;\n  margin-bottom: 0.5rem;\n  letter-spacing: 0.5px;\n}\n\n.wage-amount {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #10B981;\n}\n\n.wage-card-highlight .wage-amount {\n  color: #3B82F6;\n}\n\n.wage-insights {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  background: #F9FAFB;\n  border-radius: 8px;\n}\n\n.wage-insight-item {\n  font-size: 0.85rem;\n  color: #374151;\n  line-height: 1.5;\n}\n\n.insight-positive {\n  color: #10B981;\n  font-weight: 600;\n}\n\n.wage-note {\n  font-size: 0.8rem;\n  color: #6B7280;\n  padding: 0.75rem;\n  background: #FFFBEB;\n  border-left: 3px solid #F59E0B;\n  border-radius: 4px;\n}\n\n/* Career Path Steps Response */\n.chatbot-career-path-response {\n  max-width: 100%;\n}\n\n.career-steps-timeline {\n  position: relative;\n  padding-left: 2rem;\n}\n\n.career-step-item {\n  position: relative;\n  margin-bottom: 2rem;\n  padding-left: 2rem;\n}\n\n.career-step-item:last-child {\n  margin-bottom: 0;\n}\n\n.step-number {\n  position: absolute;\n  left: -2rem;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  background: linear-gradient(135deg, var(--primary-navy), #2d4a7c);\n  color: white;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 1rem;\n  box-shadow: 0 2px 8px rgba(27, 44, 90, 0.3);\n  z-index: 2;\n}\n\n.step-content {\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.step-content:hover {\n  border-color: var(--secondary-gold);\n  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.15);\n}\n\n.step-title {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--primary-navy);\n}\n\n.step-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.step-detail {\n  font-size: 0.85rem;\n  color: #374151;\n  line-height: 1.5;\n}\n\n.step-detail strong {\n  color: var(--primary-navy);\n  font-weight: 600;\n  margin-right: 0.5rem;\n}\n\n.step-connector {\n  position: absolute;\n  left: -0.75rem;\n  top: 2.5rem;\n  bottom: -2rem;\n  width: 2px;\n  background: linear-gradient(to bottom, var(--primary-navy), #E2E8F0);\n  z-index: 1;\n}\n\n/* Tip Box */\n.chatbot-tip-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #EFF6FF;\n  border-left: 4px solid #3B82F6;\n  border-radius: 8px;\n  margin-top: 1rem;\n}\n\n.tip-icon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.chatbot-tip-box p {\n  margin: 0;\n  font-size: 0.85rem;\n  font-style: italic;\n  color: #374151;\n  line-height: 1.5;\n}\n\n/* Enhanced Links */\n.chatbot-link {\n  color: #3B82F6;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s ease;\n}\n\n.chatbot-link:hover {\n  color: #2563EB;\n  text-decoration: underline;\n}\n\n/* Mobile Responsiveness for New Styles */\n@media (max-width: 768px) {\n  .emoji-title {\n    font-size: 1.1rem;\n  }\n\n  .job-posting-item,\n  .business-listing-item {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .job-posting-number,\n  .business-number {\n    align-self: flex-start;\n  }\n\n  .wage-columns {\n    grid-template-columns: 1fr;\n  }\n\n  .wage-amount {\n    font-size: 1.25rem;\n  }\n\n  .career-steps-timeline {\n    padding-left: 1rem;\n  }\n\n  .career-step-item {\n    padding-left: 1.5rem;\n  }\n\n  .step-number {\n    left: -1rem;\n    width: 2rem;\n    height: 2rem;\n    font-size: 0.85rem;\n  }\n\n  .step-connector {\n    left: 0;\n  }\n}\n\n/* Reduced Motion Support */\n@media (prefers-reduced-motion: reduce) {\n  .chatbot-toggle-button,\n  .chatbot-header-button,\n  .chatbot-send-button,\n  .chatbot-message-bubble,\n  .chatbot-input,\n  .chatbot-response-table tr {\n    transition: none;\n  }\n  \n  .chatbot-toggle-button:hover,\n  .chatbot-header-button:hover,\n  .chatbot-send-button:hover:not(:disabled) {\n    transform: none;\n  }\n  \n  .chatbot-loading-dot {\n    animation: none;\n    opacity: 0.7;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
